import {UmpireClub} from '../umpire-club';
import {UmpireCompetition} from '../umpire-competition';
import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireSeason} from '../umpire-season';

export interface UmpireComponentClubList
  extends UmpireComponent<UmpireComponentTypeEnum.CLUB_LIST> {
  clubs: UmpireClub[];
  competition: UmpireCompetition;
  season?: UmpireSeason | undefined;
  show_current: boolean;
}
